import { ICheckResult, IVisitorBanListEntry } from 'common/services/visitor-ban-list-service/visitor-ban-list.service.types.';

export const getNotesFromCheckResult = (data: ICheckResult) => {
  let result = '';

  data.candidates.forEach((candidate) => {
    result += `Approved despite Advisory ban list ${getDecisionText(candidate.decision)} with ${getEntryInfoText(
      candidate.visitorBanEntry,
    )}; `;
  });

  return result;
};

const getEntryInfoText = (entry: IVisitorBanListEntry) => {
  if (entry.type === 'person') {
    return `name: ${entry.firstName} ${entry.lastName}`;
  }
  if (entry.type === 'vehicle') {
    return `tag: ${entry.licensePlate}`;
  }
  if (entry.type === 'company') {
    return `company: ${entry.companyName}`;
  }
};

const getDecisionText = (decision: string) => {
  if (decision === 'match') {
    return 'exact match';
  } else {
    return 'partial match';
  }
};
